import { GobyApiCookieType } from '$extensionSrc/utils/enums'

import { apiOrigin, sharedCookieDomain } from '../consts/urlConsts'
import * as cookies from '../utils/cookies'

async function getCookie(
  name: GobyApiCookieType,
  incomingApiOrigin?: string,
): Promise<string | undefined> {
  if (typeof chrome === 'undefined' || !chrome.cookies) {
    return undefined
  }

  let url = incomingApiOrigin
  if (!url) {
    url = apiOrigin
  }

  const cookie = await cookies.getCookieIgnoreHostPermissionErrors({
    name,
    url,
  })

  if (!cookie) {
    return undefined
  }
  return cookie.value
}

async function setCookie(
  name: GobyApiCookieType,
  value: string,
  expirationDate?: number,
): Promise<void> {
  if (typeof chrome === 'undefined' || !chrome.cookies) {
    return
  }

  await cookies.setCookie({
    name,
    domain: sharedCookieDomain,
    sameSite: 'lax',
    secure: true,
    url: apiOrigin,
    value,
    ...(expirationDate !== undefined && { expirationDate }),
  })
}

async function removeCookie(name: GobyApiCookieType): Promise<void> {
  if (typeof chrome === 'undefined' || !chrome.cookies) {
    return
  }

  await cookies.removeCookieIgnoreHostPermissionErrors({
    name,
    url: apiOrigin,
  })
}

// Called by getAnonymousUserId in track AND by background-script as a part of
// the Chrome messaging process
export async function getAnonymousUserIdCookie(
  incomingApiOrigin?: string,
): Promise<string | undefined> {
  return getCookie(GobyApiCookieType.ANONYMOUS_USER_ID, incomingApiOrigin)
}

// Called by setAnonymousUserId in track AND by background-script as a part of
// the Chrome messaging process
export async function setAnonymousUserIdCookie(
  anonymousUserId: string,
): Promise<void> {
  await setCookie(GobyApiCookieType.ANONYMOUS_USER_ID, anonymousUserId)
}

export async function removeAnonymousUserIdCookie(): Promise<void> {
  await removeCookie(GobyApiCookieType.ANONYMOUS_USER_ID)
}

export async function getInstallationIdCookie(
  incomingApiOrigin?: string,
): Promise<string | undefined> {
  return getCookie(GobyApiCookieType.INSTALLATION_ID, incomingApiOrigin)
}

export async function setInstallationIdCookie(
  installationId: string,
): Promise<void> {
  await setCookie(GobyApiCookieType.INSTALLATION_ID, installationId)
}
